module.exports = __webpack_public_path__ + "static/blog-bg-41fd72afdee60967c550c8eff019cfb4.jpg";